// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"2318aa80","416":"3654a04f","453":"9f74482a","538":"16c0f19b","566":"57de70b1","882":"54caeaac"}[chunkId] + ".chunk.js";
};